export const messengersMapIcons: Record<number, string> = {
  1: 'telegram-hover',
  2: 'whatsApp',
  3: 'skype',
  4: 'viber',
};
